import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, InputLabel, Select, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import SelectFormItem from "components/Input/Select";
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { CheckboxFormItem, InputNumberForm, TextBoxForm } from "components/Input";
import Divider from "components/Divider";
import "./Register.css";
import { FiArrowRight, FiArrowLeft } from "react-icons/fi";
import React, { useState } from "react";
import { RegisterContext } from "..";
import TableUI from "components/TableUI";
import { ColumnProps } from "components/TableUI/TableUI";
import { BtnAdd, BtnDeleteTable, BtnEditTable, BtnSaveIcon, BtnCancelIcon } from "components/Button";
import { AiFillEdit } from "react-icons/ai";
import { DatePickerFromItem } from "components/Input/DatePicker";
import { List } from 'linqts';
import { TEducationalRecord } from "./RegisterClass";
import { undefinedOrNull } from "utilities/Function";
import { SwAlert } from "components/Alert";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
const StepForm3 = () => {
  const [open, setOpen] = React.useState(false);
  const { handleNext, handleBack, arrStudy, setarrStudy, objMasterData } = React.useContext(RegisterContext);
  const [nEditID, setnEditID] = useState(null);
  const [dAdmissionDate,setdAdmissionDate] = useState(new Date(1955, 1, 1));
  const [dEndDate,setdEndDate] = useState(new Date());
  const handleClickOpen = () => {
    setOpen(true);
  };


  const objSchema = yup.object().shape({
    nEducationLevelID: yupFormSchemas.string("ระดับการศึกษา", { required: true }),
    sInstitution: yupFormSchemas.string("สถาบัน", { required: true }),
    sBranch: yupFormSchemas.string("สาขาวิชา", { required: true }),
    nGPA: yupFormSchemas.string("GPA", { required: true }),
    dAdmissionDate: yupFormSchemas.string("วันที่เข้าศึกษา", { required: true }),
    dGraduationDate: yupFormSchemas.string("วันที่จบศึกษา", { required: true }),
  });

  const form = useForm({
    resolver: yupResolver(objSchema),
    shouldUnregister: false,
    shouldFocusError: true,
    mode: "all",
  });
  const ColumnData: ColumnProps[] = [{
    id: "nNo",
    name: "ลำดับ",
    width: "5%",
  },
  {
    id: "sEducationLeve",
    name: "ระดับ",
    width: "15%",
    cellAlign: "left"
  },
  {
    id: "sInstitution",
    name: "สถาบัน",
    width: "30%",
    cellAlign: "left"
  },
  {
    id: "sBranch",
    name: "สาขา",
    width: "30%",
    cellAlign: "left"
  },
  {
    id: "nGPA",
    name: "GPA",
    width: "10%",
    cellAlign: "right"
  },
  {
    id: "Action",
    name: "",
    width: "5%",
    renderCell: (item) => {
      return (
        <div style={{ display: "inline-flex", textAlign: "center" }}>
          <BtnEditTable onClick={() => { onEdit(item) }} />
          <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDelete(item) }} />
        </div>
      )
    }
  }]
  const onDelete = (obj: TEducationalRecord) => {
    SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
      setarrStudy(new List<TEducationalRecord>(arrStudy || []).Where(w => w.nID != obj.nID).ToArray())
    });
  }
  const onEdit = (obj: TEducationalRecord) => {
    setnEditID(obj.nID);
    form.setValue("nEducationLevelID", undefinedOrNull(obj.nEducationLevelID, "string"));
    form.setValue("sInstitution", undefinedOrNull(obj.sInstitution, "string"));
    form.setValue("sBranch", undefinedOrNull(obj.sBranch, "string"));
    form.setValue("nGPA", undefinedOrNull(obj.nGPA, "string"));
    form.setValue("dAdmissionDate", undefinedOrNull(obj.dAdmissionDate, "string"));
    form.setValue("dGraduationDate", undefinedOrNull(obj.dGraduationDate, "string"));
    handleClickOpen();
  }
  const onSave = () => {
    let qEducationLevel = new List<any>(objMasterData.lstEducationLevel || []).FirstOrDefault(w => w.value == form.getValues("nEducationLevelID"));
    if (nEditID) {
      let qStudy = new List<TEducationalRecord>(arrStudy || []).FirstOrDefault(w => w.nID == nEditID);
      if (qStudy) {
        qStudy.dAdmissionDate = undefinedOrNull(form.getValues("dAdmissionDate"), "dateToString");
        qStudy.dGraduationDate = undefinedOrNull(form.getValues("dGraduationDate"), "dateToString");
        qStudy.nEducationLevelID = undefinedOrNull(form.getValues("nEducationLevelID"), "number");
        qStudy.nGPA = undefinedOrNull(form.getValues("nGPA"), "number");
        qStudy.sBranch = undefinedOrNull(form.getValues("sBranch"), "string");
        qStudy.sEducationLeve = qEducationLevel ? qEducationLevel.label : "";
        qStudy.sInstitution = undefinedOrNull(form.getValues("sInstitution"), "string");
      }
    } else {
      let lstarrStudy = new List<TEducationalRecord>(arrStudy || []).ToList();
      let MaxID = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nID) + 1 : 1
      let MaxNo = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nNo) + 1 : 1
      let data: TEducationalRecord = {
        nID: MaxID,
        nNo: MaxNo,
        dAdmissionDate: undefinedOrNull(form.getValues("dAdmissionDate"), "dateToString"),
        dGraduationDate: undefinedOrNull(form.getValues("dGraduationDate"), "dateToString"),
        nEducationLevelID: undefinedOrNull(form.getValues("nEducationLevelID"), "number"),
        nGPA: undefinedOrNull(form.getValues("nGPA"), "number"),
        nOrderID: MaxNo,
        sBranch: undefinedOrNull(form.getValues("sBranch"), "string"),
        sEducationLeve: qEducationLevel ? qEducationLevel.label : "",
        sInstitution: undefinedOrNull(form.getValues("sInstitution"), "string"),
      }
      setarrStudy([...arrStudy, { ...data }])
    }
    handleClose(null, "");
  };
  const handleClose = (event: object, reason: string) => {
    if (reason != "backdropClick") {
      form.setValue("nEducationLevelID", null);
      form.setValue("sInstitution", null);
      form.setValue("sBranch", null);
      form.setValue("nGPA", null);
      form.setValue("dAdmissionDate", null);
      form.setValue("dGraduationDate", null);
      form.clearErrors();
      setnEditID(null);
      setOpen(false);
    }
  };
  const onClickNext = () => {
    if ((arrStudy || []).length > 0) {
      handleNext()
    } else {
      SwAlert.Warning(AlertTitle.Warning, "กรุณาระบุข้อมูลการประวัติการศึกษาของท่าน", () => { });
    }
  }
  return (

    <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1}>
      <Grid item md={12} xs={12}>
        <Divider><div id="divEducation"><p>ข้อมูลการประวัติการศึกษา</p><p style={{ fontSize: "12px", marginLeft: "5px", marginTop: "5px" }}> (เรียงจากปัจจุบันไปหาอดีต)</p></div></Divider>
      </Grid>
      <Grid item md={12} xs={12}>
        <TableUI column={ColumnData || []}
          row={arrStudy || []} />
      </Grid>
      <Grid item md={12} xs={12}>
        <BtnAdd onClick={handleClickOpen} />
      </Grid>
      <Grid item md={6} xs={6}>
        <Grid marginTop={4} container direction="row" alignItems="start" justifyContent="start" sx={{}}>
          <button className="buttonBack" onClick={handleBack}>
            <FiArrowLeft />
            <span>กลับ</span>
          </button>
        </Grid>
      </Grid>
      <Grid item md={6} xs={6}>
        <Grid marginTop={4} container direction="row" alignItems="end" justifyContent="end" sx={{}}>
          <button className="buttonNext" onClick={onClickNext}>
            <span>ต่อไป</span>
            <FiArrowRight />
          </button>
        </Grid>
      </Grid>
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown

        sx={{ borderRadius: "23px" }}
      >
        <DialogTitle style={{
          borderBottom: "1px solid #FD8D14"
        }}><AiFillEdit /> รายละเอียดการศึกษา</DialogTitle>
        <DialogContent>
          <FormProvider {...form}>
            <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
              <Grid item md={4} xs={12}>
                <SelectFormItem options={objMasterData.lstEducationLevel || []} name={"nEducationLevelID"} label={"ระดับการศึกษา"} required />
              </Grid>
              <Grid item md={8} xs={12}>
                <TextBoxForm name={"sInstitution"} label={"สถาบัน"} required maxLength={250}/>
              </Grid>
              <Grid item md={10} xs={12}>
                <TextBoxForm name={"sBranch"} label={"สาขาวิชา "} required maxLength={250}/>
              </Grid>
              <Grid item md={2} xs={12}>
                <InputNumberForm name={"nGPA"} label={"GPA"} required maxInteger={1} maxDigits={2} maxLength={4.00}/>
              </Grid>
              <Grid item md={4} xs={12}>
                <DatePickerFromItem name={"dAdmissionDate"} label={"วันที่เข้าศึกษา"}
                  maxDate={dEndDate} required
                  minDate={new Date(1955, 1, 1)}
                  fullWidth
                  onChange={(e) => {
                    setdAdmissionDate(e);
                    form.setValue("dGraduationDate", null);
                  }}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <DatePickerFromItem name={"dGraduationDate"} label={"วันที่จบศึกษา"}
                  maxDate={Date()}
                  fullWidth
                  onChange={(e)=> setdEndDate(e)}
                  minDate={dAdmissionDate} required/>
              </Grid>
            </Grid>
          </FormProvider>
          {/* </Box> */}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Close</Button> */}
          <BtnCancelIcon onClick={() => handleClose({}, "")} />
          <BtnSaveIcon onClick={form.handleSubmit(() => { onSave(); })} />
        </DialogActions>
      </Dialog>
    </Grid>
  )
};

export default StepForm3;
